import React from "react";
import { Link } from "react-router-dom";

// IMAGES
import HeroBg from "../img/Hero_Bg.png";

export default function Error() {
    return (
        <div className="error">
            <div className="defaultHero">
                <div className="custom-container">
                    <div className="error-text">
                        <h1>404</h1>
                        <div className="button-wrapper">
                            <Link href="" to={"/"} className="hover-e1">
                                <span className="border-left"></span>
                                <span className="border-right"></span>
                                <span className="border-top"></span>
                                <span className="border-bottom"></span>
                                Return to Home
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="bg">
                    <img src={HeroBg} alt="" />
                </div>
            </div>
        </div>
    );
}
